import { logger } from './logger'

/**
 * Registers window-level error handlers that catch JS errors escaping React's
 * tree and unhandled promise rejections. Call once during app bootstrap.
 */
export function registerGlobalErrorHandlers() {
  globalThis.addEventListener('error', (event: ErrorEvent) => {
    logger.error('Uncaught error', {
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      err: event.error instanceof Error ? event.error : undefined,
    })
  })

  globalThis.addEventListener(
    'unhandledrejection',
    (event: PromiseRejectionEvent) => {
      const reason = event.reason
      logger.error('Unhandled promise rejection', {
        err: reason instanceof Error ? reason : undefined,
        reason: reason instanceof Error ? undefined : String(reason),
      })
    },
  )
}
